import api from '@/core/lib/fetch/api';
import { RoutesEnum } from '@/core/lib/router/router.context';
import type { DocumentsFileResult } from '@/core/types/document';
import { documentsFileResult } from '@/core/types/document';

const query = {
  cgu: async () =>
    api.get<DocumentsFileResult>({
      url: RoutesEnum.CGU,
      schema: documentsFileResult,
    }),
};

export default { query };
